import React, { useState } from 'react'
import { createFeedback, updateFeedback } from '../../Api/feedbacks'
import { toast } from 'react-toastify'
import logAppEvent from '../../Api/appEventsLogging'
import { useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { Button, Flex, Image, Input, Text } from '@chakra-ui/react'

const Feedback = ({
  reference_id,
  feedback_type,
  isActionItems,
  actionItemsTotal,
}) => {
  const [feedbackId, setFeedbackId] = useState(null)
  const [showFeedback, setShowFeedback] = useState(true)

  const [rating, setRating] = useState(0)
  const [comment, setComment] = useState('')
  
  const user = useSelector((state) => state?.user?.data)
  const [searchParams] = useSearchParams()
  
  const handleEventLog = (eventType) => {
    if (eventType === 'smileyClicked') {
      let eventName

      switch (feedback_type) {
      case 1:
        eventName = 'transumm_fdbk_submit_summary_click'
        break
      case 3:
        eventName = 'transumm_fdbk_submit_transcripts_click'
        break
      case 4:
        eventName = 'transumm_smiley_fdbk_actionitems_click'
        break
      default:
        eventName = 'transumm_fdbk_submit_default_click'
      }

      const eventId = searchParams.get('eventId')
      logAppEvent(eventName, {
        user_id: user?.id,
        event_id: eventId,
      })   
      return
    }

    if (eventType === 'feebackInputSubmit') {
      let eventName
      switch (feedback_type) {
      case 1:
        eventName = 'transumm_fdbk_submit_summary_click'
        break
      case 3:
        eventName = 'transumm_fdbk_submit_transcripts_click'
        break
      case 4:
        eventName = 'transumm_fdbk_submit_actionitems_click'
        break
      default:
        eventName = 'transumm_fdbk_submit_default_click'
      }
      logAppEvent(eventName, {
        user_id: user?.id,
      })
      return
    }
  }

  const handleFeedback = async (feedback_type, rating, comment) => {
    if (!reference_id) return
    if (feedback_type < 0 || feedback_type > 4) return
    if (rating < 0 || rating > 3) {
      toast.error('Rating is required')
      return
    }

    if (feedbackId) {
      const apiResponse = await updateFeedback(feedbackId, {
        rating,
        comment: comment?.trim() || '',
      })
      return apiResponse
    }

    const apiResponse = await createFeedback({
      feedback_type,
      comment: comment?.trim() || '',
      rating,
      reference_id,
    })
    if (apiResponse?.feedbackId) setFeedbackId(apiResponse.feedbackId)
    return apiResponse
  }

  const handleSmileyFeedbackClick = async (rating) => {
    setRating(rating)
    const apiResponse = await handleFeedback(feedback_type, rating, comment)
    if (apiResponse) handleEventLog('smileyClicked')
  }

  const handleFeedbackInputSubmit = async () => {
    const apiResponse = await handleFeedback(feedback_type, rating, comment)
    if (!apiResponse) return
    setShowFeedback(false)
    handleEventLog('feebackInputSubmit')
  }

  return (
    <Flex minH='60px' mx='24px' alignItems='center'>
      {!showFeedback ? (
        <>
          <Text color='#898A93' flex={1} mr={2}>
            Thank you!
          </Text>
        </>
      ) : feedbackId ? (
        <>
          <Input
            color='#222222'
            fontWeight='500'
            py='20px'
            mr='8px'
            px={0}
            h='auto'
            border='none'
            value={comment}
            lineHeight='19px' 
            fontSize='16px'
            onChange={(e) => setComment(e.target.value)}
            placeholder='Give feedback...'
            onKeyDown={(e) => e.key === 'Enter' && handleFeedbackInputSubmit()}
          />
        </>
      ) : (
        <Text color='#898A93' flex={1} mr={2}>
          Give feedback
        </Text>
      )}
      {[{
            activeIcon: '/assets/icons/feedback_positive_active.svg', 
            icon: '/assets/icons/feedback_positive.svg' 
          }, {
            activeIcon: '/assets/icons/feedback_negative_active.svg',
            icon: '/assets/icons/feedback_negative.svg',
          }].map(({activeIcon, icon}, index) => {
            if (isActionItems && actionItemsTotal < 0) return <></>
            return (
              <Button 
                key={`feedback-${index}`} 
                onClick={() => handleSmileyFeedbackClick(index+1)}
                minW={0}
                p={2}
                h='auto'
                ml={2}
              >
                {rating === index+1 ? (
                  <Image boxSize={4} src={activeIcon} />
                ) : (
                  <Image boxSize={4} src={icon} />
                )}
              </Button>
            )
          })}
    </Flex>
  )
}

export default Feedback
